import { Reducer } from "redux";

import { FacilityTypeMasterResponse } from "../models/Api/PatientList";
import { FacilityTypeMasterDispatchTypes } from "../models/DispatchTypes/Service";
import { FacilityTypeMasterActionDispatchType } from "../constants/Service";

export const defaultFacilityTypeMaster = [
  {
    facilityTypeName: "",
  },
];

const initialState: FacilityTypeMasterResponse = {
  loading: false,
  response: defaultFacilityTypeMaster,
};

const FacilityTypeMasterReducer: Reducer<
  FacilityTypeMasterResponse,
  FacilityTypeMasterDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case FacilityTypeMasterActionDispatchType.FACILITY_TYPE_MASTER_BY_TEXT_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case FacilityTypeMasterActionDispatchType.FACILITY_TYPE_MASTER_BY_TEXT_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case FacilityTypeMasterActionDispatchType.FACILITY_TYPE_MASTER_BY_TEXT_RESET: {
      return {
        ...state,
        response: [],
        loading: false,
      };
    }
  }
  return state;
};

export default FacilityTypeMasterReducer;
